import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { customStyle } from "../../algorithms/styleDirection";
import { resolver } from "../../API/middlewares/resolveRequests";
import { applicantLookups } from "../../API/services/utilities";
import { getCommunityLength } from "../../API/store/actions/community";
import { getCommunityTaskForm } from "../../API/store/actions/tasks";
import Lang from "../../userPreferences/staticWords";
import AddUserForm from "../admin/userManage/adduser/addUserForm";
import DisccusionForm from "../discussion/discussionForm";
import CreateNewProject from "../projects/createNewProjectPopup";
import CardWithTitleAndIcon from "../reusableComponents/cardWithTitleButton";
import ModalComponent from "../reusableComponents/modal";
import CreateNewTask from "../tasks/createNewTaskPopup";
import { FouramIcon, ProjectsIcon, TasksIcon, UsersIcon } from "./icons";
import Button from "./../sharedComponents/buttons/button";
import { getPostsOfMonth } from "../../API/store/actions/discussion/discussion";
import DiscussionCard from "./../discussion/discussionCard";
import ReactTooltip from "react-tooltip";
import AddMemberToCommunity from "./addUserToCommunity";
import { ScrollToTop } from "../../algorithms";

const AboutCommunity = ({ details, procAdded, setProcAdded }) => {
  const communityId = useSelector((state) => state.community.communityId?.id);
  const userToken = useSelector((state) => state.login.userToken);
  const dispatch = useDispatch();
  const userLogged = useSelector((state) => state.login.userData);
  const community = useSelector((state) => state.community.communityId);

  //task Modal
  const [AdminTaskMembersList, setAdminTaskMembersList] = useState([]);
  const [communityLength, setCommunityLength] = useState([]);
  const [TaskMembersList, setTaskMembersList] = useState([]);
  const [forums, setForums] = useState(null);
  const [TaskStatusDropdownList, setTaskStatusDropdownList] = useState([]);
  const [PriorityDropdownList, setPriorityDropdownList] = useState([]);
  const [dropdownLists, setDropdownLists] = useState(null);

  const [showTask, setShowTask] = useState(false);
  const [showAddUser, setShowAddUser] = useState(false);
  const communityTaskForm = useSelector(
    (state) => state.tasks.getCommunityTaskForm
  );
  const onShowTask = () => {
    setShowTask(true);
  };
  const renderTaskModal = (communityTaskForm) => {
    return (
      <CreateNewTask
        communityTaskForm={communityTaskForm}
        AdminTaskMembersList={AdminTaskMembersList}
        setAdminTaskMembersList={setAdminTaskMembersList}
        TaskMembersList={TaskMembersList}
        setTaskMembersList={setTaskMembersList}
        TaskStatusDropdownList={TaskStatusDropdownList}
        setTaskStatusDropdownList={setTaskStatusDropdownList}
        PriorityDropdownList={PriorityDropdownList}
        setPriorityDropdownList={setPriorityDropdownList}
        communityId={communityId} //when we put communities
        setProcAdded={setProcAdded}
        procAdded={procAdded}
        show={showTask}
        isActivity={false}
        onHide={() => setShowTask(false)}
      />
    );
  };

  //project Modal
  const [showProject, setShowProject] = useState(false);
  const onShowProject = () => {
    setShowProject(true);
  };
  const renderProjectModal = () => {
    return (
      <CreateNewProject
        communityId={communityId} //when we put communities
        setProjAdded={setProcAdded}
        projAdded={procAdded}
        show={showProject}
        onHide={() => setShowProject(false)}
      />
    );
  };

  //discussion Modal
  const [showDiscussion, setShowDiscussion] = useState(false);
  const onShowDiscussion = () => {
    setShowDiscussion(true);
  };
  const renderDiscussionModal = () => {
    return (
      <DisccusionForm
        userLogged={userLogged}
        userToken={userToken}
        communityId={communityId} //when we put communities
        setProcAdded={setProcAdded}
        procAdded={procAdded}
        show={showDiscussion}
        onHide={() => setShowDiscussion(false)}
      />
    );
  };

  useEffect(() => {
    resolver(getCommunityLength, setCommunityLength, communityId, userToken);
    dispatch(getCommunityTaskForm(communityId, userToken));
    resolver(getPostsOfMonth, setForums, communityId, 1, 1000, userToken);
    ScrollToTop();
  }, [procAdded, communityId]);

  if (details && communityLength)
    return (
      <>
        <ModalComponent
          hasImage={
            <img
              src={"/assets/images/Group 8275.png"}
              width={"100%"}
              height={"100%"}
            />
          }
          title={"اضافة عضو للبرنامج البحثي"}
          modalVisible={showAddUser}
          setModalVisible={setShowAddUser}
          body={
            <AddMemberToCommunity
              modalVisible={showAddUser}
              setModalVisible={setShowAddUser}
              userToken={userToken}
            />
          }
        />
        <div className="d-flex flex-column">
          <div
            className="col-12 d-flex justify-content-center"
            style={{ backgroundColor: "rgb(242, 242, 242)" }}
          >
            <div className="d-flex flex-wrap justify-content-center col-12 container">
              {/* <div
                className="col-md-3 col-6 pb-5 d-flex flex-column align-items-center justify-content-center position-relative"
                data-tip
                data-for={customStyle("l11")}
              >
                <CardWithTitleAndIcon
                  containerStyle={`d-flex flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4`}
                  style={{
                    backgroundColor: "rgb(242, 242, 242)",
                    cursor: "unset",
                  }}
                  borderColor={"rgb(242, 242, 242)"}
                  height={120}
                  width={165}
                  hasSVG={
                    <ProjectsIcon length={communityLength?.data?.projects} />
                  }
                  imgHeight={75}
                  imgWidth={90}
                  containerImgHeight={75}
                  containerImgWidth={90}
                />
                <ReactTooltip
                  id={customStyle("l11")}
                  type="info"
                  effect="solid"
                  place={"bottom"}
                  backgroundColor="#0a58ca"
                  arrowColor="#0a58ca"
                >
                  <span>{Lang.projectsNavTab}</span>
                </ReactTooltip>
                {community?.adminProject && (
                  <Button
                    containerStyle={"col-sm-5 col-6"}
                    onClick={() => {
                      onShowProject();
                    }}
                    content={Lang.add}
                    customStyle={{ borderRadius: 10 }}
                  />
                )}
              </div> */}

              <div
                className="col-md-3 col-6 pb-5 d-flex flex-column align-items-center justify-content-center position-relative"
                data-tip
                data-for={customStyle("l8")}
              >
                <CardWithTitleAndIcon
                  containerStyle={`d-flex flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4`}
                  style={{
                    backgroundColor: "rgb(242, 242, 242)",
                    cursor: "unset",
                  }}
                  borderColor={"rgb(242, 242, 242)"}
                  height={120}
                  width={165}
                  hasSVG={<TasksIcon length={communityLength?.data?.tasks} />}
                  imgHeight={75}
                  imgWidth={90}
                  containerImgHeight={75}
                  containerImgWidth={90}
                />
                <ReactTooltip
                  id={customStyle("l8")}
                  type="info"
                  effect="solid"
                  place={"bottom"}
                  backgroundColor="#0a58ca"
                  arrowColor="#0a58ca"
                >
                  <span>{Lang.tasksNavTab}</span>
                </ReactTooltip>
                {community?.adminTask && (
                  <Button
                    containerStyle={"col-sm-5 col-6"}
                    onClick={() => {
                      onShowTask();
                    }}
                    content={Lang.add}
                    customStyle={{ borderRadius: 10 }}
                  />
                )}
              </div>

              {/* <div
                className="col-md-3 col-6 pb-5 d-flex flex-column align-items-center justify-content-center position-relative"
                data-tip
                data-for={customStyle("l9")}
              >
                <CardWithTitleAndIcon
                  containerStyle={`d-flex flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4`}
                  style={{
                    backgroundColor: "rgb(242, 242, 242)",
                    cursor: "unset",
                  }}
                  borderColor={"rgb(242, 242, 242)"}
                  height={120}
                  width={165}
                  hasSVG={<FouramIcon length={communityLength?.data?.forums} />}
                  imgHeight={85}
                  imgWidth={100}
                  containerImgHeight={85}
                  containerImgWidth={100}
                />
                <ReactTooltip
                  id={customStyle("l9")}
                  type="info"
                  effect="solid"
                  place={"bottom"}
                  backgroundColor="#0a58ca"
                  arrowColor="#0a58ca"
                >
                  <span>{Lang.discussionCirclesNavTab}</span>
                </ReactTooltip>
                <Button
                  containerStyle={"col-sm-5 col-6"}
                  onClick={() => {
                    onShowDiscussion();
                  }}
                  content={Lang.add}
                  customStyle={{ borderRadius: 10 }}
                />
              </div> */}

              <div
                className="col-md-3 col-6 pb-5 d-flex flex-column align-items-center justify-content-center position-relative"
                data-tip
                data-for={customStyle("l10")}
              >
                <CardWithTitleAndIcon
                  containerStyle={`d-flex flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4`}
                  style={{
                    backgroundColor: "rgb(242, 242, 242)",
                    cursor: "unset",
                  }}
                  borderColor={"rgb(242, 242, 242)"}
                  height={120}
                  width={165}
                  hasSVG={<UsersIcon length={communityLength?.data?.members} />}
                  imgHeight={75}
                  imgWidth={90}
                  containerImgHeight={75}
                  containerImgWidth={90}
                />

                <ReactTooltip
                  id={customStyle("l10")}
                  type="info"
                  effect="solid"
                  place={"bottom"}
                  backgroundColor="#0a58ca"
                  arrowColor="#0a58ca"
                >
                  <span>{Lang.Members}</span>
                </ReactTooltip>
                {community?.adminCommunity && (
                  <Button
                    containerStyle={"col-sm-5 col-6"}
                    onClick={() => {
                      setShowAddUser(true);
                    }}
                    content={Lang.add}
                    customStyle={{ borderRadius: 10 }}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="d-flex flex-column container col-12 mt-5">
            <div className="d-flex col-12 justify-content-center justify-content-md-start">
              <img
                src="/assets/images/icons/fi-br-flag.png"
                alt="About Community"
                width={25}
                height={25}
              />
              <p className="mx-3 fw-bold" style={{ fontSize: 18 }}>
                {Lang.aboutCommunity}
              </p>
            </div>
            <div className="d-flex col-12 justify-content-center justify-content-md-start">
              <p style={{ textAlign: "justify" }}>{details.description}</p>
            </div>
          </div>

          {renderTaskModal(communityTaskForm?.data)}
        </div>
      </>
    );
  return <div></div>;
};

export default AboutCommunity;
